export default {
    message: {
        "availability": "Availability",
        "shipping_preparation": "Estimated delivery time",
        "days": "Days",
        "quantity": "Quantity",
        "add_to_cart": "Add to cart",
        "quantity_no_available": "The requested quantity is currently not available",
        "product_no_available": "Product coming soon",
        "choose": "Choose",
        "Loading": "Loading ...",

    },
}
